import React from 'react';
import { 
    Box, 
    Button, 
    Typography, 
    TextField, 
    Grid, 
    Paper, 
    IconButton,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

/**
 * Component for a single venue contact person
 */
const ContactPerson = ({ 
    id, 
    firstName, 
    lastName,
    role,
    email,
    phone,
    isPrimary,
    onDelete, 
    onChange 
}) => {
    // Available role options
    const roleOptions = [
        'Owner',
        'Manager',
        'Events Coordinator',
        'Sales Representative',
        'Booking Manager',
        'Operations Manager',
        'Administrative Staff',
        'Marketing Manager',
        'Other'
    ];

    return (
        <Paper elevation={2} sx={{ p: 3, mb: 3, position: 'relative' }}>
            <IconButton 
                color="error" 
                size="small" 
                onClick={() => onDelete(id)}
                sx={{ position: 'absolute', top: 10, right: 10 }}
                disabled={isPrimary}
            >
                <DeleteIcon />
            </IconButton>
            
            <Typography variant="h6" gutterBottom>
                {isPrimary ? 'Primary Contact Person' : `Additional Contact #${id}`}
            </Typography>
            
            {isPrimary && (
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    This is the main contact person for your venue
                </Typography>
            )}
            
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="First Name"
                        value={firstName}
                        onChange={(e) => onChange(id, 'firstName', e.target.value)}
                        required
                        error={!firstName}
                        helperText={!firstName ? "First name is required" : ""}
                    />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Last Name"
                        value={lastName}
                        onChange={(e) => onChange(id, 'lastName', e.target.value)}
                        required
                        error={!lastName}
                        helperText={!lastName ? "Last name is required" : ""}
                    />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                        <InputLabel id={`role-label-${id}`}>Role/Position</InputLabel>
                        <Select
                            labelId={`role-label-${id}`}
                            value={role || ''}
                            label="Role/Position"
                            onChange={(e) => onChange(id, 'role', e.target.value)}
                            error={!role}
                        >
                            {roleOptions.map(option => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                        {!role && <FormHelperText error>Role is required</FormHelperText>}
                    </FormControl>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Email Address"
                        type="email"
                        value={email}
                        onChange={(e) => onChange(id, 'email', e.target.value)}
                        required
                        error={!email}
                        helperText={!email ? "Email is required" : ""}
                    />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Phone Number"
                        value={phone}
                        onChange={(e) => onChange(id, 'phone', e.target.value)}
                        required
                        error={!phone}
                        helperText={!phone ? "Phone number is required" : ""}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ContactPerson; 